module.exports = __webpack_public_path__ + "media/images/logos/ziprecruiter-63a9dad2be778be01f5e44d5c98dda0b.svg";